
let DEBUG_FORCE_DAY = null//'weekend'//'weekday' //weekend or null.

//A handy function to tell if today is Saturday or not.
export const isTodaySaturday = () => {

  if(DEBUG_FORCE_DAY) {
    return DEBUG_FORCE_DAY == 'weekday' ? false : true
  }

  const today = new Date();
  const dayOfWeek = today.getDay();
  return (dayOfWeek == 6)
}

const days = ['sunday','monday','tuesday','wednesday','thursday','friday', 'saturday']

export const getDay = () => {

  if(DEBUG_FORCE_DAY) {
    return DEBUG_FORCE_DAY == 'weekday' ? 'monday' : 'saturday'
  }

  const today = new Date();
  const dayOfWeek = today.getDay();
  const day = days[dayOfWeek]
  if(day == 'saturday' || day == 'sunday') {
    return 'saturday'
  } else {
    return 'monday'
  }
}

export const isWeekday = () => {

  if(DEBUG_FORCE_DAY) {
    return DEBUG_FORCE_DAY == 'weekday' ? true : false
  }

  const today = new Date();
  const dayOfWeek = today.getDay();
  const day = days[dayOfWeek]
  if(day == 'saturday' || day == 'sunday') {
    return false
  } else {
    return true
  }
}

export const scheduleKey = (day, routeID) => {
  return `${day}-${routeID}` 
}